module.exports = __webpack_public_path__ + "media/images/ruby_logo-03af0f588a12b32e0e7e263f082c9792.svg";